import { AdministrateResourceDeleteButton } from "../../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../../components/AdministrateTable";
import { useDestroyPermission, useUpdatePermission } from "../../../utils";
import { History } from "../../sandbox/release/History";
import { EditAutoStatusParsingSettingModal } from "./EditAutoStatusParsingSettingModal";

export const AutoStatusParsingSettingActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("AutoStatusParsingSetting", row.original.id);
  const [canUpdate] = useUpdatePermission("AutoStatusParsingSetting", row.original.id);

  return (
    <>
      {canUpdate && (
        <EditAutoStatusParsingSettingModal
          color="link"
          setting={row.original}
          onUpdate={(row) => {
            refresh();
            setMessage(`Updated Setting with ID: ${row.id}`);
          }}
        />
      )}

      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/auto_status_parsing_settings/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Auto Status Parsing Setting ${row.original.messageRegex}.`);
          }}
          onError={setError}
        />
      )}

      <History entityName="AutoStatusParsingSetting" subjectId={row.original.id} />
    </>
  );
};
